@charset "UTF-8";

/* src/app/forms/market-place-tabs/market-place-tabs.component.scss */
:host {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.content-tabs {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
}
.tabs-spin {
  height: 100%;
  display: block;
}
:host ::ng-deep .tabs-spin > .ant-spin-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
nz-tabs {
  height: 100%;
}
:host ::ng-deep .custom-tabs .ant-tabs-content,
:host ::ng-deep .custom-tabs .ant-tabs-tabpane {
  height: 100%;
}
.block {
  animation: 0.5s fadeIn;
  animation-fill-mode: forwards;
  opacity: 0;
}
.tab-order {
  background: color-mix(in srgb, var(--tem-ink) 12%, transparent);
  border-radius: var(--tem-radius);
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
  min-height: 60px;
}
.list-order {
  width: 300px;
  max-width: 100%;
  border: solid 1px var(--tem-border);
  min-height: 60px;
  display: block;
  border-radius: var(--tem-radius);
  background: var(--tem-surface);
  box-shadow: var(--tem-shadow);
  overflow: auto;
  max-height: 300px;
  height: 100%;
}
.list-order-box {
  padding: 15px 10px;
  border-bottom: solid 1px var(--tem-border);
  color: var(--tem-ink);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  font-size: 12px;
  font-weight: 500;
  margin-left: 10px;
  margin-right: 10px;
}
.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow:
    0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14),
    0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.list-order-box:last-child {
  border: none;
}
.list-order.cdk-drop-list-dragging .list-order-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.list-order-custom-placeholder {
  background: var(--tem-surface-2);
  border: dotted 3px var(--tem-border);
  min-height: 50px;
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.content {
  padding: 5px;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
}
.mktplace {
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.gridclass {
  height: 100%;
  width: 100%;
  position: absolute;
}
.tabcontent {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.cardcontent {
  height: 25%;
}
.transformimage {
  padding-top: 4px;
  transform: scale(1.5);
}
.transformimage2 {
  padding-top: 4px;
  transform: scale(2);
}
.transformimage3 {
  padding-top: 4px;
  transform: scale(3);
}
/*# sourceMappingURL=market-place-tabs.component.css.map */
